import React from "react";
import { connect } from "react-redux";
import { some, SUCCESS_CODE } from "../../../../constants/constants";
import { actionGetBookerInfo } from "../bookerAction";
import { withRouter } from "react-router-dom";
import { checkDeviceType, isEmpty } from "utils/helpers/helpers";
import { useSnackbar } from "notistack";
import { snackbarSetting } from "modules/common/Elements";
import SearchBookerMainDesktop from "./SearchBookerMainDesktop";
import SearchBookerMainTablet from "./SearchBookerMainTablet";
import SearchBookerMainMobile from "./SearchBookerMainMobile";

interface Props {
  history: some;
}

const SearchBookerMain: React.FC<Props> = (props) => {
  const [results, setResults] = React.useState<some>({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { history } = props;

  const getBookerInfo = async (id: string) => {
    try {
      const res: some = await actionGetBookerInfo(id);
      if (res?.code === SUCCESS_CODE) {
        setResults(res?.data);
        if (!isEmpty(res?.data))
          //pass results props along the route
          history.push({
            pathname: `bookerInfo`,
            state: res?.data,
          });
      } else {
        enqueueSnackbar(
          res?.message,
          snackbarSetting((key) => closeSnackbar(key), { color: "error" })
        );
      }
    } catch (error) {}
  };

  return (
    <div>
      {checkDeviceType()?.device?.type === "mobile" ? (
        <SearchBookerMainMobile
          results={results}
          getBookerInfo={getBookerInfo}
        />
      ) : checkDeviceType()?.device?.type === "tablet" ? (
        <SearchBookerMainTablet
          results={results}
          getBookerInfo={getBookerInfo}
        />
      ) : (
        <SearchBookerMainDesktop
          results={results}
          getBookerInfo={getBookerInfo}
        />
      )}
    </div>
  );
};

export default connect()(withRouter(SearchBookerMain));
